export default __webpack_public_path__ + "static/media/Kuthcheman Longsword.b2e23838.jpg";